<div class="fill-parent">
  <div class="report-head" *ngIf="!isout">
    <div class="report-back">
  <button class="main-btn empty-back-btn" (click)="navigateBack()"><img src="/assets/images/back.svg" />Chart Dashboard</button></div>
    <div class="report-title detail-page-title margin-l-l">
      Books Read by Title
    </div>
    <div class="report-date">
      <mat-form-field (click)="picker.open()"  class="report-picker" appearance="outline">
        <input matInput [matDatepicker]="picker" [(ngModel)]="startDate" placeholder="Start Date">
        <mat-datepicker-toggle class="picker-icon" matPrefix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker (closed)="onSelectDate()"  #picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field (click)="picker2.open()"  class="report-picker" appearance="outline">
        <input matInput [matDatepicker]="picker2" [(ngModel)]="endDate" placeholder="Start Date">
        <mat-datepicker-toggle matPrefix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker (closed)="onSelectDate()"  #picker2></mat-datepicker>
      </mat-form-field>
      <!--<mat-datepicker-toggle  matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-input  [rangePicker]="picker">
        <input matStartDate [(ngModel)]="startDate" placeholder="Start date">
        <input matEndDate [(ngModel)]="endDate" placeholder="End date">
      </mat-date-input>
      <mat-date-range-picker (closed)="onSelectDate()" #picker></mat-date-range-picker>!-->
    </div>
  </div>
  <div *ngIf="reportdata.length === 0">
    <label>No data in the selected period.</label>
  </div>
  <div class="margin-l-l report-body" *ngIf="isout" [ngStyle]="reportdata.length != 0 ? {'visibility': 'visible'} : {'visibility': 'hidden'}">
    <ngx-charts-bar-horizontal
    [view] = "viewsize"
    [scheme]="colorScheme"
    [results]="reportdata"
    [gradient]="gradient"
    [barPadding]="6"
    [yAxis]="showYAxis"
    [xAxisLabel]="xAxisLabel"
    [xScaleMin]= "xScaleMin"
    [roundEdges]=true
    [maxYAxisTickLength]="maxYAxisTickLength"
    [xAxis]="showXAxis"
    [xScaleMin] = "0"
    [showXAxisLabel]="showXAxisLabel">

    </ngx-charts-bar-horizontal>
  </div>
  <div class="margin-l-l" *ngIf="!isout">
  <ng-scrollbar style="height: 500px; overflow: auto;" [ngStyle]="reportdata.length != 0 ? {'visibility': 'visible'} : {'visibility': 'hidden'}">
    <ngx-charts-bar-horizontal
    [view] = "viewsize"
    [scheme]="colorScheme"
    [results]="reportdata"
    [gradient]="gradient"
    [barPadding]="6"
    [yAxis]="showYAxis"
    [xAxisLabel]="xAxisLabel"
    [xScaleMin]= "xScaleMin"
    [roundEdges]=true
    [maxYAxisTickLength]="maxYAxisTickLength"
    [xAxis]=true
    [xScaleMin] = "0"
    [showXAxisLabel]=true>

    </ngx-charts-bar-horizontal>
   </ng-scrollbar>
   </div>
</div>
